var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"shadow-card white",class:_vm.$isMobile ? 'tile ' + _vm.customClass : _vm.customClass + ' rounded-lg ',attrs:{"dark":_vm.dark,"color":_vm.color,"tile":"","disabled":_vm.disabled}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }